/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Undertraining_OverloadInputs */

const en_coach_undertraining_overload = /** @type {(inputs: Coach_Undertraining_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are carrying significant fatigue despite a low recent training load relative to your history. This may indicate accumulated stress from non-training factors. Prioritize recovery before adding volume.`)
};

const de_coach_undertraining_overload = /** @type {(inputs: Coach_Undertraining_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist stark ermüdet, obwohl dein aktueller Umfang niedrig ist. Das kann auf angestauten Stress hindeuten — nicht nur vom Training. Gönn dir erst Erholung, bevor du wieder mehr machst.`)
};

/**
* | output |
* | --- |
* | "You are carrying significant fatigue despite a low recent training load relative to your history. This may indicate accumulated stress from non-training fact..." |
*
* @param {Coach_Undertraining_OverloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_undertraining_overload = /** @type {((inputs?: Coach_Undertraining_OverloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Undertraining_OverloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_undertraining_overload(inputs)
	return de_coach_undertraining_overload(inputs)
});